const firebaseConfig = {
    apiKey: "AIzaSyCwmfXdN0BTRAuNRLQ6gyvicVQfpFy5Ges",
    authDomain: "doctors-portal-site-e81ca.firebaseapp.com",
    databaseURL: "https://doctors-portal-site-e81ca.firebaseio.com",
    projectId: "doctors-portal-site-e81ca",
    storageBucket: "doctors-portal-site-e81ca.appspot.com",
    messagingSenderId: "686156596012",
    appId: "1:686156596012:web:186570b27fd8c80d03a289"
  };

  export default firebaseConfig;